import { render } from "./PagarView.vue?vue&type=template&id=64b92582&scoped=true"
import script from "./PagarView.vue?vue&type=script&lang=js"
export * from "./PagarView.vue?vue&type=script&lang=js"

import "./PagarView.vue?vue&type=style&index=0&id=64b92582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b92582"]])

export default __exports__